import React, { FC, useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import './OrderFailure.scss';
import AppButton from '../../../components/ui/components/Buttons/AppButton/AppButton';
import Container from '../../../components/ui/layouts/Container/Container';
import Page from '../../../components/common/Page/Page';
import icon from '../../../assets/images/order-failure-icon.svg';

import { RouteNames } from '../../../routes';
import { parseSearchParams } from '../../../helpers/url';
import { useDispatch } from 'react-redux';
import { clearPaymentServerData, clearStoringOnServerData } from '../../../store/order/order-reducer';
import { OrderPaymentResponse } from '../../../types/order';
import OrderSuccessWithPaymentData from './components/OrderSuccessWithPaymentData/OrderSuccessWithPaymentData';
import { useTranslation } from 'react-i18next';

const OrderFailure = () => {
   const { search } = useLocation();
   const [t] = useTranslation();

   const params = parseSearchParams(search);
   const message = params['message'];
   const dispatch = useDispatch();

   const [paymentData, setPaymentData] = useState<OrderPaymentResponse>(null);

   useEffect(() => {
      const paymentDataFromLocalStorate = sessionStorage.getItem('paymentServerData');
      setPaymentData(paymentDataFromLocalStorate ? JSON.parse(paymentDataFromLocalStorate) : null);

      //instant clear LS
      sessionStorage.removeItem('paymentServerData');

      return () => {
         dispatch(clearPaymentServerData());
         dispatch(clearStoringOnServerData());
      };
   }, []);

   return (
      <Page>
         <Container>
            <div className="order-failure">
               <h1 className="order-failure__title">
                  {message}

               </h1>

               <div className="order-failure__image">
                  <img src={icon} alt="" />
               </div>

               {paymentData?.paymentDetails
                  ? <OrderSuccessWithPaymentData paymentData={paymentData} />
                  : (
                     <>
                        <div className={'order-failure__buttons-container'}>
                           <AppButton className="order-failure__button" size="middle" to={'/'}>
                              {t('Повернутися на головну')}
                           </AppButton>

                           <AppButton className="order-failure__button" size="middle" to={'/order'}>
                              {t('Повернутися до кошику')}
                           </AppButton>
                        </div>
                     </>
                  )}

            </div>
         </Container>
      </Page>
   );
};

export default OrderFailure;
